







































































































import Super from "@/pv4-super-class"
import { Component } from "vue-property-decorator"

@Component
export default class Value extends Super {
  dataTags: any = null

  mounted() {
    this.load()
  }

  load() {
    this.http
      .get(`/data-tag?eventID=${this.eventId}`)
      .then(res => (this.dataTags = res.data))
  }

  createTag() {
    let data = { dataTagCode: "NewTag", eventID: this.eventId }
    this.http
      .post(`/data-tag?eventID=${this.eventId}`, data)
      .then(this.load)
      .catch(this.displayError)
  }

  saveTag(tag) {
    this.http
      .put(`/data-tag/${tag.dataTagID}?eventID=${this.eventId}`, tag)
      .then(this.load)
      .catch(this.displayError)
  }

  deleteTag(tag) {
    this.http
      .delete(`/data-tag/${tag.dataTagID}?eventID=${this.eventId}`)
      .then(this.load)
      .catch(this.displayError)
  }
}
